import React, { useEffect, useState } from 'react';
import Header from './Header';
import DefaultSidebar from './Sidebar'
import axios from 'axios';
import { Link } from 'react-router-dom';



function ListClientProgramme(){

    // console.log(`HERE id is ${idChoose}`);
    const [data, setDate] = useState([])
    const [search, setSearch] = useState('');
    // const [open, setOpen] = useState('block')

    useEffect(() => {
        axios.get(`${process.env.REACT_APP_IP}:${process.env.REACT_APP_PORT}/InterfaceTizenDevice`)
            .then(res => {
                // console.log(res.data);
                setDate(res.data)
            }).catch(err => console.log(err))
    }, [])


    const scrollToTop = () =>{ 
        window.scrollTo({ 
          top: 0,  
          behavior: 'smooth'
        }); 
    };
    
    const arr = data.filter((item) => {
        return search.toLowerCase() === '' 
            ? item 
            :  item._client_name.toLowerCase().includes(search.toLowerCase()) || item._app_type.toLowerCase().includes(search.toLowerCase()) ||  item._pin_code.toLowerCase().includes(search.toLowerCase()) 
    })
    .map((data, index) => {

        return (
            // <Link to={`/programme/${data._pin_code}`}>
            <Link to={`/programme/${data._pin_code}`}
                state={{ clientName: data._client_name}}
            >

                <div className="block rounded-2xl border border-slate-200 bg-white p-5 text-left shadow-sm transition hover:border-slate-300 hover:shadow-md">
                    <h5 className="mb-1 text-lg font-semibold tracking-tight text-slate-800">{data._client_name}</h5>
                        <h6 className="text-sm font-medium text-slate-600">{data._app_type}</h6>
                        <p className="mt-1 text-sm text-slate-500">Code PIN : {data._pin_code}</p>
                </div>
            </Link>
        )
    })
    return (
        <div className="mx-auto max-w-7xl px-4 py-6 sm:px-6">
            {/* <Header /> */}
            <div className="mb-4">
                <h1 className="text-xl font-semibold text-slate-800">Programmes clients</h1>
                <p className="text-sm text-slate-500">Sélectionnez un client pour accéder à son programme</p>
            </div>
            <div className="mb-6 max-w-md">
                {/* <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-8 h-8 absolute left-1 cursor-pointer" onClick={() => setOpen(open === `hidden`  ? 'block' : 'hidden')} >
                    <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
                </svg> */}
                <div className="relative flex h-10 items-center rounded-xl border border-slate-200 bg-white shadow-sm focus-within:border-indigo-500 focus-within:ring-2 focus-within:ring-indigo-500/20">
                    <svg xmlns="http://www.w3.org/2000/svg" className="ml-3 h-5 w-5 text-slate-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                    </svg>

                    <input
                        className="h-full w-full rounded-xl bg-transparent px-3 text-sm text-slate-800 placeholder-slate-400 outline-none"
                        type="text"
                        id="search"
                        placeholder="Rechercher un client, un code PIN..."
                        onChange={(e) => setSearch(e.target.value)}
                        />
                </div>
            </div>
            <main className="mt-4">
                {/* <DefaultSidebar  isOpen={open} /> */}
                <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
                    {arr}
                </div>
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-10 h-10 fixed bottom-16 right-6 cursor-pointer text-slate-400 hover:text-slate-600" onClick={() => scrollToTop() }>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M15 11.25l-3-3m0 0l-3 3m3-3v7.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
            </main>
        </div>
    )
}

export default ListClientProgramme;